module.exports = __webpack_public_path__ + "img/oak-green-cropped.f0c2e35f.jpg";